export default __webpack_public_path__ + "static/HeistnHeat-9b23ce15d8f6a74c3abcf9594d07a148.png";